<footer>
  <div class="logo-footer">
    <svg
      [routerLink]="'/'"
      width="200"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 318.49 100.19"
    >
      <defs>
        <style>
          .cls-1 {
            fill: #fff;
          }
          .cls-2 {
            fill: #f0655c;
          }
        </style>
      </defs>
      <title>logotype_frannartur_duque_34</title>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            class="cls-1"
            d="M71.21,24.22V14.87H63.57V49h7.64V32.09c3.07-5.62,11.34-4.57,11.34-4.57V14.87S75,14.87,71.21,24.22Z"
          />
          <path
            class="cls-1"
            d="M215.17,24.22V14.87h-7.64V49h7.64V32.09c3.07-5.62,11.35-4.57,11.35-4.57V14.87S218.94,14.87,215.17,24.22Z"
          />
          <path
            class="cls-1"
            d="M307.15,24.22V14.87H299.5V49h7.65V32.09c3.06-5.62,11.34-4.57,11.34-4.57V14.87S310.92,14.87,307.15,24.22Z"
          />
          <path
            class="cls-1"
            d="M41.74,49h7.64V27.45h8.45V14.87H49.38V13.31S49.21,10,51.47,10h6.36V0H51.47s-9.73.28-9.73,13.31v1.62l-6.6-.06V27.45h6.6Z"
          />
          <path
            class="cls-1"
            d="M246.46,6.73l-7.64.06v8h-6.6V27.41h6.6v9.42c0,13,9.72,12.15,9.72,12.15h6.37V40.25h-6.37c-2.26,0-2.08-3.42-2.08-3.42V27.41h8.45V14.83h-8.45Z"
          />
          <path
            class="cls-1"
            d="M87.73,32.11C87.73,41.44,94.55,49,103,49a14.78,14.78,0,0,0,12.12-6.65V49h7.52V14.87h-7.52v7c-2.79-4-7.18-6.92-12.12-6.92C94.55,14.93,87.73,22.77,87.73,32.11Zm7,0c0-4.57,4.56-8.55,10.19-8.55s10.19,4.26,10.19,8.83-4.56,7.87-10.19,7.87S94.71,36.74,94.71,32.16Z"
          />
          <path
            class="cls-1"
            d="M167,32.11c0,9.33,6.82,16.9,15.24,16.9a14.78,14.78,0,0,0,12.12-6.65V49h7.53V14.87h-7.53v7c-2.79-4-7.18-6.92-12.12-6.92C173.83,14.93,167,22.77,167,32.11Zm7,0c0-4.57,4.56-8.55,10.19-8.55s10.19,4.26,10.19,8.83-4.56,7.87-10.19,7.87S174,36.74,174,32.16Z"
          />
          <path
            class="cls-1"
            d="M27.38,61.8a14.63,14.63,0,0,0-12.14-6.55C6.82,55.25,0,62.69,0,72s6.82,17,15.24,17a14.88,14.88,0,0,0,12.14-6.81v7.12h7.53l-.09-48.74H27.38ZM17.17,80.5C11.54,80.5,7,76.65,7,72.08s4.56-8.14,10.19-8.14,10.19,3.57,10.19,8.14S22.8,80.5,17.17,80.5Z"
          />
          <path
            class="cls-1"
            d="M161.27,31c0-9.34-5.28-16-13.7-16-4.64,0-8.8,3-11.6,6.62V14.87h-7.64V49H136V29.91c1.26-3.21,4.65-6.2,8.63-6.2a9,9,0,0,1,9,8.67L153.69,49h7.64Z"
          />
          <path
            class="cls-1"
            d="M286,34.5a9.35,9.35,0,0,1-8.62,5.79c-5.05,0-9-3.69-9-8.26l-.06-17.16h-7.64l0,18.55C260.71,42.76,266,49,274.42,49A14.91,14.91,0,0,0,286,42.77V49h7.65V14.87H286Z"
          />
          <path
            class="cls-1"
            d="M145.19,74.89a9.37,9.37,0,0,1-8.63,5.8c-5.05,0-9-3.69-9-8.27l-.06-17.16h-7.64l.06,18.55c0,9.34,5.28,15.56,13.7,15.56a14.92,14.92,0,0,0,11.6-6.21v6.21h7.64V55.26h-7.64Z"
          />
          <path
            class="cls-1"
            d="M65.9,74.89a9.35,9.35,0,0,1-8.62,5.8c-5.05,0-9-3.69-9-8.27l-.06-17.16H40.55l.05,18.55c0,9.34,5.29,15.56,13.71,15.56A14.88,14.88,0,0,0,65.9,83.16v6.21h7.65V55.26H65.9Z"
          />
          <path
            class="cls-1"
            d="M106.56,61.8a14.63,14.63,0,0,0-12.14-6.55C86,55.25,79.18,62.69,79.18,72S86,89.34,94.42,89.34c5,0,9.36-3,12.14-7.09v17.94h7.53V55.12h-7.53Zm-10.21,19c-5.62,0-10.19-4.12-10.19-8.69,0-4.21,4.57-8.28,10.19-8.28s10.19,3.71,10.19,8.28S102,80.77,96.35,80.77Z"
          />
          <ellipse
            class="cls-2"
            cx="189.56"
            cy="6.7"
            rx="5.36"
            ry="4.35"
            transform="translate(50.78 136) rotate(-45)"
          />
          <path
            class="cls-1"
            d="M176.84,81.07c-4.92,0-9.1-2.61-10.54-6.21h28.81a16.52,16.52,0,0,0,.23-2.74c0-9.42-8.21-16.92-18.35-16.92s-18.35,7.5-18.35,16.92S166.86,89.18,177,89.18A18.44,18.44,0,0,0,193.8,79H184A12.69,12.69,0,0,1,176.84,81.07Zm0-17.84c4.77,0,8.84,2.3,10.4,5.72h-20.8C168,65.53,172.08,63.23,176.84,63.23Z"
          />
        </g>
      </g>
    </svg>
  </div>
  <div class="slogan">¡La vida brilla si le pones Comedia!</div>
  <div>
    <button [routerLink]="'/contacto'" class="contact-button" mat-button>
      Contacto
    </button>
  </div>
  <div class="social-container">
    <div class="social">
      <a href="https://www.instagram.com/franarturduque/" target="_blank">
        <fa-icon [icon]="faInstagram"></fa-icon>
      </a>
    </div>
    <div class="social">
      <a href="https://www.facebook.com/FranarturDuque/" target="_blank">
        <fa-icon [icon]="faFacebookF"></fa-icon>
      </a>
    </div>
    <div class="social">
      <a href="https://twitter.com/FranarturDuque/" target="_blank">
        <fa-icon [icon]="faTwitter"></fa-icon>
      </a>
    </div>
    <div class="social">
      <a href="https://www.youtube.com/FranarturDuque/" target="_blank">
        <fa-icon [icon]="faYoutube"></fa-icon>
      </a>
    </div>
    <div class="social">
      <a href="https://www.linkedin.com/in/franarturduque/" target="_blank">
        <fa-icon [icon]="faLinkedin"></fa-icon>
      </a>
    </div>
    <div class="social">
      <a href="https://www.imdb.com/name/nm2907273/" target="_blank">
        <fa-icon [icon]="faImdb"></fa-icon>
      </a>
    </div>
    <div class="social">
      <a
        href="https://es.wikipedia.org/wiki/Fran%C3%A1rtur_Duque"
        target="_blank"
      >
        <fa-icon [icon]="faWikipediaW"></fa-icon>
      </a>
    </div>
  </div>
  <div class="divider-full"></div>
  <div class="copyright">
    <div class="terminos-container">
      <div class="terminos">Términos</div>
      <span>|</span>
      <div class="terminos">Privacidad</div>
    </div>
    Franártur Duque <span class="rights">®</span> &
    <span class="sircomediaa">
      Sircomedia Group <span class="rights">®</span>
    </span>
    <br />
    Todos los Derechos Reservados.
  </div>
</footer>
